import React, { useState } from 'react';
import { NavLink, Link } from 'react-router-dom';
import ThemeToggle from './ThemeToggle';
import ColorPicker from './ColorPicker';
import LanguageToggle from './LanguageToggle';
import { useLanguage } from '../context/LanguageContext';
import { useTheme } from '../context/ThemeContext';

const Sidebar = () => {
  const { t } = useLanguage();
  const { theme } = useTheme();
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);

  return (
    <nav className="sidebar">
      <div className="sidebar-header">
        <div className="logo">
          <Link to="/" style={{ textDecoration: 'none', color: 'inherit' }} onClick={closeMenu}>
            <img
              src={theme === 'dark' ? '/Sara Næss/SaraNæss-White.png' : '/Sara Næss/SaraNæss-Black.png'}
              alt="Sara Næss Logo"
            />
          </Link>
        </div>
        <button className="hamburger-btn" onClick={toggleMenu} aria-label="Toggle menu">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="24" height="24">
            {isOpen ? (
              <path d="M18 6L6 18M6 6l12 12" />
            ) : (
              <path d="M3 12h18M3 6h18M3 18h18" />
            )}
          </svg>
        </button>
      </div>

      <div className={`sidebar-content ${isOpen ? 'open' : ''}`}>
        <ul className="nav-links">
          <li>
            <NavLink to="/" className={({ isActive }) => (isActive ? 'active' : '')} onClick={closeMenu}>
              {t('nav.home')}
            </NavLink>
          </li>
          <li>
            <NavLink to="/work" className={({ isActive }) => (isActive ? 'active' : '')} onClick={closeMenu}>
              {t('nav.work')}
            </NavLink>
          </li>
          <li>
            <NavLink to="/contact" className={({ isActive }) => (isActive ? 'active' : '')} onClick={closeMenu}>
              {t('nav.contact')}
            </NavLink>
          </li>
        </ul>
        <div className="socials">
          {/* Container for controls */}
          <div style={{ display: 'flex', gap: '15px', alignItems: 'center', justifyContent: 'center' }}>
            <ThemeToggle />
            <ColorPicker />
            <LanguageToggle />
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Sidebar;
